// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-editor-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: var(--color-overlay-bg, rgba(0,0,0,0.5));
  /* nested 모달 (다른 모달 위에 띄움) — 부모 modal(z:1001) 보다 위. */
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.panel-editor {
  background: white;
  border-radius: 10px;       /* 다른 모달과 통일 (8 → 10) */
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  width: 620px;
  max-width: calc(95vw / var(--app-zoom, 1));
  height: calc(85vh / var(--app-zoom, 1));          /* 고정 높이 — 내부 컨텐츠 변화에도 모달 크기 일정 */
  max-height: calc(90vh / var(--app-zoom, 1));
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;        /* 다른 모달과 통일 (12 → 10) */
  background: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
}

.panel-editor-header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.panel-editor-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
}

.panel-editor-body {
  padding: 20px;             /* 다른 모달과 통일 (16 → 20) */
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1;
  min-height: 0;
}

.panel-editor-row {
  display: flex;
  gap: 12px;
}

.panel-editor-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: #374151;
  font-weight: 500;
}

.panel-editor-input {
  padding: 7px 10px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  font-size: 13px;
  color: #374151;
  background: white;
  font-weight: 400;
  box-sizing: border-box;
}

.panel-editor-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,0.1);
}

.panel-editor-textarea {
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  font-family: var(--font-mono);
  font-size: 12px;
  color: #374151;
  background: white;
  resize: vertical;
  min-height: 120px;
  box-sizing: border-box;
}

.panel-editor-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,0.1);
}

.panel-editor-footer {
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 8px;
  align-items: center;
}

.panel-editor-btn {
  padding: 7px 14px;
  border-radius: 5px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid #d1d5db;
  background: white;
  color: #374151;
}

.panel-editor-btn:hover {
  background: #f3f4f6;
}

.panel-editor-btn-primary {
  background: #3b82f6;
  color: white;
  border-color: #2563eb;
}

.panel-editor-btn-primary:hover {
  background: #2563eb;
}

.panel-editor-btn-danger {
  background: #ef4444;
  color: white;
  border-color: #dc2626;
}

.panel-editor-btn-danger:hover {
  background: #dc2626;
}

/* Dark mode */
[data-theme="dark"] .panel-editor {
  background: var(--color-bg-tertiary);
  color: var(--color-text);
}

[data-theme="dark"] .panel-editor-header {
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .panel-editor-header h3 {
  color: var(--color-text);
}

[data-theme="dark"] .panel-editor-close {
  color: var(--color-text-muted);
}

[data-theme="dark"] .panel-editor-label {
  color: var(--color-text-secondary);
}

[data-theme="dark"] .panel-editor-input,
[data-theme="dark"] .panel-editor-textarea {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}

[data-theme="dark"] .panel-editor-input:focus,
[data-theme="dark"] .panel-editor-textarea:focus {
  border-color: var(--color-accent-fg);
}

[data-theme="dark"] .panel-editor-footer {
  border-top-color: var(--color-border);
}

[data-theme="dark"] .panel-editor-btn {
  background: var(--color-bg-secondary);
  color: var(--color-text);
  border-color: var(--color-border);
}

[data-theme="dark"] .panel-editor-btn:hover {
  background: var(--color-hover);
}

/* ============================================================ */
/* 확장 모드 — 2컬럼 레이아웃(입력 + 미리보기) + 템플릿/미리보기  */
/* ============================================================ */
.panel-editor-wide {
  width: 1080px;
  max-width: calc(97vw / var(--app-zoom, 1));
}
.panel-editor-split {
  flex-direction: row;
  gap: 20px;
  padding: 16px;
}
/* split 모드에서는 외부 body 스크롤 금지 — form/preview 각자 내부에서 처리 */
.panel-editor-body.panel-editor-split {
  overflow: hidden;
}
.panel-editor-form {
  flex: 1 1 58%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;     /* 내부 자식이 스크롤 책임 */
}
/* 상단 입력 필드 묶음 — 차트 옵션 미펼침 시 활성, 내부 스크롤 */
.panel-editor-form-top {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  padding-right: 4px;
}
.panel-editor-preview {
  flex: 1 1 42%;
  min-width: 0;
  min-height: 0;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.panel-editor-preview-header {
  padding: 8px 12px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  background: #f3f4f6;
}
.panel-editor-preview-header small {
  font-weight: 400;
  color: #6b7280;
  font-size: 11px;
}
.panel-editor-preview-body {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1;
  min-height: 0;
}
.panel-editor-preview-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  padding-bottom: 6px;
  border-bottom: 1px dashed #d1d5db;
}
.panel-editor-preview-meta {
  font-size: 11px;
  color: #6b7280;
  line-height: 1.6;
  padding-top: 4px;
  border-top: 1px dashed #d1d5db;
}
.panel-editor-preview-meta strong {
  color: #374151;
  margin-right: 4px;
}

/* 강조 필드(데이터소스) */
.panel-editor-prominent {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 4px;
}
.panel-editor-prominent > select {
  background: white;
}
/* 라벨 텍스트 한 줄 묶음 — 텍스트 + * 가 반드시 같은 줄에 위치하도록.
   부모 .panel-editor-label 이 flex-column 이라 span 없이 두면 *가 다른 줄로 내려감. */
.panel-editor-label-text {
  display: inline-flex;
  align-items: baseline;
  white-space: nowrap;
}
.panel-editor-required {
  color: #ef4444;
  font-weight: 700;
  margin-left: 4px;
}
.panel-editor-hint {
  color: #6b7280;
  font-size: 11px;
  line-height: 1.5;
}
.panel-editor-hint-inline {
  color: #6b7280;
  font-size: 11px;
  font-weight: 400;
  margin-left: 4px;
}
.panel-editor-hint-inline code {
  background: #f3f4f6;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 10px;
  color: #1d4ed8;
}
.panel-editor-hint code {
  background: #f3f4f6;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 10px;
  color: #1d4ed8;
}
.panel-editor-input-error {
  border-color: #dc2626 !important;
  background: #fef2f2 !important;
}
[data-theme="dark"] .panel-editor-hint-inline {
  color: var(--color-text-muted);
}
[data-theme="dark"] .panel-editor-hint-inline code,
[data-theme="dark"] .panel-editor-hint code {
  background: var(--color-bg-secondary);
  color: #93c5fd;
}
[data-theme="dark"] .panel-editor-input-error {
  background: rgba(220, 38, 38, 0.12) !important;
  border-color: #ef4444 !important;
}

.panel-editor-btn-secondary {
  background: #f3f4f6;
  border-color: #d1d5db;
  color: #4b5563;
}
.panel-editor-btn-secondary:hover {
  background: #e5e7eb;
}

/* 다크 모드 보강 */
[data-theme="dark"] .panel-editor-preview {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-preview-header {
  background: var(--color-bg-tertiary);
  border-bottom-color: var(--color-border);
  color: var(--color-text);
}
[data-theme="dark"] .panel-editor-preview-header small,
[data-theme="dark"] .panel-editor-preview-meta {
  color: var(--color-text-muted);
}
[data-theme="dark"] .panel-editor-preview-title {
  color: var(--color-text);
  border-bottom-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-preview-meta {
  border-top-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-preview-meta strong {
  color: var(--color-text);
}
[data-theme="dark"] .panel-editor-prominent {
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(59, 130, 246, 0.3);
}
[data-theme="dark"] .panel-editor-hint {
  color: var(--color-text-muted);
}
[data-theme="dark"] .panel-editor-btn-secondary {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text);
}
[data-theme="dark"] .panel-editor-btn-secondary:hover {
  background: var(--color-hover);
}

/* 작은 화면 — 가로 공간 부족 시 세로 스택 */
@media (max-width: 900px) {
  .panel-editor-wide { width: 620px; }
  .panel-editor-split { flex-direction: column; }
  .panel-editor-preview { min-height: 320px; }
}

/* ============================================================ */
/* 차트 옵션 섹션 — 컴팩트 + 내부 스크롤 (모달 전체 스크롤 방지) */
/* ============================================================ */
@keyframes panel-editor-fade-swap {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* 폼 상단 탭 — 기본 / 차트 옵션 / 전역변수.
   각 탭 클릭 시 하위 conditional content 가 swap 되고 활성 탭은 파란 underline 강조. */
.panel-editor-tabs {
  display: flex;
  gap: 0;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
  margin-bottom: 4px;
}
.panel-editor-tab {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 7px 14px;
  cursor: pointer;
  font-size: 13px;
  color: #6b7280;
  margin-bottom: -1px;   /* 부모 border-bottom 과 겹쳐 두꺼워지는 것 방지 */
  transition: color 160ms ease, border-color 160ms ease, background-color 160ms ease;
}
.panel-editor-tab:hover {
  color: #374151;
  background: #f9fafb;
}
.panel-editor-tab-active {
  color: #1e40af;
  border-bottom-color: #3b82f6;
  font-weight: 600;
}
@media (prefers-reduced-motion: reduce) {
  .panel-editor-tab { transition: none; }
}

/* 차트 옵션 펼침 / 접힘 시 내용물 fade-in (mount 직후 1회). */
.panel-editor-form-top,
.panel-editor-section {
  animation: panel-editor-fade-swap 160ms ease-out;
}

/* OS-level reduced motion 선호 시 애니메이션/트랜지션 비활성 */
@media (prefers-reduced-motion: reduce) {
  .panel-editor-form-top,
  .panel-editor-section {
    transition: none;
    animation: none;
  }
}
/* 차트 옵션 본문 — flex:1 로 form 영역을 채우며, 내부에서 스크롤 */
.panel-editor-section {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fafafa;
  overflow: hidden;
}
.panel-editor-section-content {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.panel-editor-subsection {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px 8px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
}
.panel-editor-subsection-title {
  font-size: 12px;
  font-weight: 600;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 2px;
}
/* 컴팩트 row — 작은 gap, 모든 자식 라벨 한 줄 */
.panel-editor-row-compact {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}
.panel-editor-row-compact .panel-editor-label {
  font-size: 11px;
  font-weight: 500;
  gap: 2px;
}
.panel-editor-row-compact .panel-editor-input {
  padding: 4px 6px;
  font-size: 12px;
}
.panel-editor-checkbox-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #374151;
  cursor: pointer;
}
.panel-editor-checkbox-label input[type="checkbox"] {
  cursor: pointer;
}
/* Y컬럼 테이블 — flex:1 로 남은 공간 차지, 내부 스크롤 */
.panel-editor-yfield-scroll {
  flex: 1 1;
  min-height: 80px;
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: white;
}
.panel-editor-yfield-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.panel-editor-yfield-table thead {
  position: sticky;
  top: 0;
  background: #f9fafb;
  z-index: 1;
}
.panel-editor-yfield-table th {
  text-align: left;
  font-weight: 500;
  color: #6b7280;
  padding: 4px 8px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 11px;
}
.panel-editor-yfield-table td {
  padding: 3px 8px;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
}
.panel-editor-yfield-table tr:last-child td {
  border-bottom: none;
}
.panel-editor-yfield-table code {
  background: #f3f4f6;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 11px;
  color: #1f2937;
}
/* 색상 선택 — 트리거 swatch + Portal 기반 중앙 모달 팝업.
   상위 overflow:hidden 에 clip 되지 않도록 document.body 에 렌더. */
.panel-editor-color-swatch {
  width: 32px;
  height: 22px;
  padding: 0;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  cursor: pointer;
  background: transparent;
  transition: border-color 160ms ease, transform 100ms ease;
}
.panel-editor-color-swatch:hover {
  border-color: #6b7280;
  transform: scale(1.05);
}

/* 모달 overlay + 본문 */
.panel-editor-color-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: panel-editor-fade-swap 160ms ease-out;
}
.panel-editor-color-modal {
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  min-width: 280px;
  max-width: calc(90vw / var(--app-zoom, 1));
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.panel-editor-color-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
}
.panel-editor-color-modal-close {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 2px;
  display: inline-flex;
  align-items: center;
  border-radius: 3px;
  transition: color 160ms ease, background-color 160ms ease;
}
.panel-editor-color-modal-close:hover {
  color: #1f2937;
  background: #e5e7eb;
}
.panel-editor-color-modal-body {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.panel-editor-color-modal-palette {
  display: grid;
  grid-template-columns: repeat(5, 36px);
  gap: 8px;
}
.panel-editor-color-modal-swatch {
  width: 36px;
  height: 36px;
  border: 2px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  padding: 0;
  transition: transform 100ms ease, border-color 100ms ease;
}
.panel-editor-color-modal-swatch:hover {
  border-color: #9ca3af;
  transform: scale(1.08);
}
.panel-editor-color-modal-swatch-active {
  border-color: #1f2937;
  transform: scale(1.08);
}
.panel-editor-color-modal-custom {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px dashed #d1d5db;
  font-size: 12px;
  color: #374151;
}
.panel-editor-color-modal-custom input[type="color"] {
  width: 36px;
  height: 28px;
  padding: 0;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  cursor: pointer;
  background: transparent;
}
.panel-editor-color-modal-hex {
  flex: 1 1;
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  font-size: 12px;
  font-family: var(--font-mono);
}

@media (prefers-reduced-motion: reduce) {
  .panel-editor-color-modal-overlay,
  .panel-editor-color-modal-swatch,
  .panel-editor-color-swatch { animation: none; transition: none; }
}
.panel-editor-input-compact {
  padding: 3px 5px;
  font-size: 11px;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  background: white;
  color: #374151;
}

/* 다크 모드 보강 */
[data-theme="dark"] .panel-editor-tabs {
  border-bottom-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-tab {
  color: var(--color-text-muted);
}
[data-theme="dark"] .panel-editor-tab:hover {
  color: var(--color-text);
  background: var(--color-hover);
}
[data-theme="dark"] .panel-editor-tab-active {
  color: #93c5fd;
  border-bottom-color: #60a5fa;
}
[data-theme="dark"] .panel-editor-section {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-subsection {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-subsection-title {
  color: var(--color-text);
}
[data-theme="dark"] .panel-editor-checkbox-label {
  color: var(--color-text-secondary);
}
[data-theme="dark"] .panel-editor-yfield-scroll {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-yfield-table thead {
  background: var(--color-bg-secondary);
}
[data-theme="dark"] .panel-editor-yfield-table th {
  color: var(--color-text-muted);
  border-bottom-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-yfield-table td {
  border-bottom-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-yfield-table code {
  background: var(--color-bg-secondary);
  color: var(--color-text);
}
[data-theme="dark"] .panel-editor-color-swatch {
  border-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-color-swatch:hover {
  border-color: var(--color-text-muted);
}
[data-theme="dark"] .panel-editor-color-modal {
  background: var(--color-bg-tertiary);
  box-shadow: 0 8px 32px rgba(0,0,0,0.6);
}
[data-theme="dark"] .panel-editor-color-modal-header {
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
  color: var(--color-text);
}
[data-theme="dark"] .panel-editor-color-modal-close {
  color: var(--color-text-muted);
}
[data-theme="dark"] .panel-editor-color-modal-close:hover {
  color: var(--color-text);
  background: var(--color-hover);
}
[data-theme="dark"] .panel-editor-color-modal-swatch:hover {
  border-color: var(--color-text-muted);
}
[data-theme="dark"] .panel-editor-color-modal-swatch-active {
  border-color: var(--color-text);
}
[data-theme="dark"] .panel-editor-color-modal-custom {
  color: var(--color-text-secondary);
  border-top-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-color-modal-custom input[type="color"] {
  border-color: var(--color-input-border);
}
[data-theme="dark"] .panel-editor-color-modal-hex {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}
[data-theme="dark"] .panel-editor-input-compact {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}

/* ============================================================ */
/* SubPanelPicker — 병합(merged) 차트의 sub-패널 선택 UI         */
/* ============================================================ */
.panel-editor-subpanel-picker { display: contents; }
.panel-editor-subpanel-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;
  padding: 6px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  min-height: 60px;
}
.panel-editor-subpanel-empty {
  color: #9ca3af;
  font-size: 12px;
  font-style: italic;
  text-align: center;
  padding: 12px 8px;
}
.panel-editor-subpanel-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 12px;
  /* 부드러운 hover (UI Conventions: 색상 한정 transition) */
  transition: border-color 160ms ease;
}
.panel-editor-subpanel-row:hover { border-color: #9ca3af; }
.panel-editor-subpanel-row-missing {
  background: #fef3c7;
  border-color: #fcd34d;
}
.panel-editor-subpanel-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: #e5e7eb;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 600;
  color: #4b5563;
  flex-shrink: 0;
}
.panel-editor-subpanel-title {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1f2937;
  font-weight: 500;
}
.panel-editor-subpanel-type {
  flex-shrink: 0;
  color: #6b7280;
  font-size: 11px;
}
.panel-editor-subpanel-type code {
  background: #e5e7eb;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 10px;
}
.panel-editor-subpanel-add { margin-top: 6px; }
.panel-editor-subpanel-warn {
  margin-top: 6px;
  padding: 6px 10px;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 4px;
  color: #92400e;
  font-size: 11px;
  /* fade-in (UI Conventions: 120~200ms ease-out) */
  animation: panel-editor-fade-swap 160ms ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .panel-editor-subpanel-row { transition: none; }
  .panel-editor-subpanel-warn { animation: none; }
}

/* 미리보기 영역 하단 — 저장 전 검증 결과 안내 ('주의') */
.panel-editor-preview-warnings {
  margin-top: 10px;
  padding: 8px 12px;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 6px;
  color: #92400e;
  font-size: 12px;
  line-height: 1.5;
  /* fade-in (UI Conventions: 120~200ms ease-out) */
  animation: panel-editor-fade-swap 160ms ease-out;
}
.panel-editor-preview-warnings-title {
  font-weight: 600;
  margin-bottom: 4px;
  color: #78350f;
}
.panel-editor-preview-warnings ul {
  margin: 0;
  padding-left: 18px;
}
.panel-editor-preview-warnings li {
  margin: 2px 0;
}
[data-theme="dark"] .panel-editor-preview-warnings {
  background: rgba(245, 158, 11, 0.12);
  border-color: rgba(245, 158, 11, 0.4);
  color: #fbbf24;
}
[data-theme="dark"] .panel-editor-preview-warnings-title { color: #fde68a; }
@media (prefers-reduced-motion: reduce) {
  .panel-editor-preview-warnings { animation: none; }
}

/* 병합 패널 — 미리보기 영역 안내 박스 */
.panel-editor-preview-merged {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 18px 14px;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 6px;
  color: #475569;
  font-size: 12px;
  text-align: center;
  animation: panel-editor-fade-swap 160ms ease-out;
}
.panel-editor-preview-merged strong {
  font-size: 13px;
  color: #1f2937;
}
.panel-editor-preview-merged small { color: #6b7280; }
@media (prefers-reduced-motion: reduce) {
  .panel-editor-preview-merged { animation: none; }
}

/* 다크 모드 */
[data-theme="dark"] .panel-editor-subpanel-list {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-subpanel-row {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
}
[data-theme="dark"] .panel-editor-subpanel-row:hover { border-color: var(--color-text-muted); }
[data-theme="dark"] .panel-editor-subpanel-row-missing {
  background: rgba(245, 158, 11, 0.15);
  border-color: rgba(245, 158, 11, 0.4);
}
[data-theme="dark"] .panel-editor-subpanel-index {
  background: var(--color-bg);
  color: var(--color-text-muted);
}
[data-theme="dark"] .panel-editor-subpanel-title { color: var(--color-text); }
[data-theme="dark"] .panel-editor-subpanel-type { color: var(--color-text-muted); }
[data-theme="dark"] .panel-editor-subpanel-type code {
  background: var(--color-bg);
  color: var(--color-text-muted);
}
[data-theme="dark"] .panel-editor-subpanel-empty { color: var(--color-text-muted); }
[data-theme="dark"] .panel-editor-subpanel-warn {
  background: rgba(245, 158, 11, 0.18);
  border-color: rgba(245, 158, 11, 0.4);
  color: #fbbf24;
}
[data-theme="dark"] .panel-editor-preview-merged {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text-secondary);
}
[data-theme="dark"] .panel-editor-preview-merged strong { color: var(--color-text); }
[data-theme="dark"] .panel-editor-preview-merged small { color: var(--color-text-muted); }

/* ===== 세션 분석 · 오라클 성능 분석 기준으로 맞춤 (2026-10-03, 모니터링 메뉴 4개 창 공통) =====
   본문 12px · 표(머리 6/8px 회색 바탕 + 아래 2px 선, 칸 5/8px + 1px 선) · 버튼·입력 30px · 필터는 리본 · 발 영역 회색 줄.
   앞 규칙을 지우지 않고 뒤에서 덮는다(분리 창·전체 화면이 같은 클래스를 쓴다). 색 전환만(all 트랜지션 아님). */
.panel-editor-body { padding: 12px 16px; }
.panel-editor-label { font-size: 12px; font-weight: 600; }
.panel-editor-input { height: 30px; box-sizing: border-box; padding: 0 10px; font-size: 12.5px; border-radius: 4px; }
textarea.panel-editor-input { height: auto; padding: 6px 10px; }
.panel-editor-textarea { font-size: 12px; border-radius: 4px; }
.panel-editor-hint { font-size: 11.5px; }
.panel-editor-footer { padding: 10px 16px; background: #f8f9fa; border-top-color: #e0e0e0; }
.panel-editor-btn {
  display: inline-flex; align-items: center; gap: 6px;
  height: 30px; box-sizing: border-box; padding: 0 14px; border-radius: 6px;
  font-size: 13px; line-height: 1;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}
.panel-editor-btn > svg { display: block; flex-shrink: 0; }
[data-theme="dark"] .panel-editor-footer { background: var(--color-bg-secondary); border-top-color: var(--color-border); }
@media (prefers-reduced-motion: reduce) { .panel-editor-btn { transition: none; } }

/* 노드를 고르며 SQL 을 고친 사실(2026-10-18) — 바뀐 것을 놓치지 않게 강조색으로 */
.panel-editor-node-note { color: #b45309; }
[data-theme="dark"] .panel-editor-node-note { color: #fbbf24; }
`, "",{"version":3,"sources":["webpack://./src/components/monitoring/PanelEditor.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,oDAAoD;EACpD,qDAAqD;EACrD,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB,QAAQ,uBAAuB;EAClD,sCAAsC;EACtC,YAAY;EACZ,0CAA0C;EAC1C,uCAAuC,WAAW,iCAAiC;EACnF,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB,SAAS,wBAAwB;EACnD,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa,cAAc,wBAAwB;EACnD,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,iEAAiE;AACjE,4CAA4C;AAC5C,iEAAiE;AACjE;EACE,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;AACA,yDAAyD;AACzD;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB,MAAM,kBAAkB;AAC1C;AACA,yCAAyC;AACzC;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;qEACqE;AACrE;EACE,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,wBAAwB;AAC1B;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;AACA;EACE,qCAAqC;AACvC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB,YAAY,EAAE;EACnC,sBAAsB,sBAAsB,EAAE;EAC9C,wBAAwB,iBAAiB,EAAE;AAC7C;;AAEA,iEAAiE;AACjE,2CAA2C;AAC3C,iEAAiE;AACjE;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;qEACqE;AACrE;EACE,aAAa;EACb,MAAM;EACN,gCAAgC;EAChC,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB,IAAI,qCAAqC;EAC5D,kFAAkF;AACpF;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,oBAAoB,gBAAgB,EAAE;AACxC;;AAEA,+CAA+C;AAC/C;;EAEE,gDAAgD;AAClD;;AAEA,gDAAgD;AAChD;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA,+CAA+C;AAC/C;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;AACA,mCAAmC;AACnC;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA,wCAAwC;AACxC;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;yDACyD;AACzD;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,yDAAyD;AAC3D;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;AAClD;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,yDAAyD;AAC3D;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE;;+BAE6B,eAAe,EAAE,gBAAgB,EAAE;AAClE;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,wCAAwC;AAC1C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA,iEAAiE;AACjE,yDAAyD;AACzD,iEAAiE;AACjE,gCAAgC,iBAAiB,EAAE;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,mCAAmC;AACrC;AACA,mCAAmC,qBAAqB,EAAE;AAC1D;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA,6BAA6B,eAAe,EAAE;AAC9C;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iDAAiD;EACjD,gDAAgD;AAClD;AACA;EACE,6BAA6B,gBAAgB,EAAE;EAC/C,8BAA8B,eAAe,EAAE;AACjD;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iDAAiD;EACjD,gDAAgD;AAClD;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;AACA,2DAA2D,cAAc,EAAE;AAC3E;EACE,iCAAiC,eAAe,EAAE;AACpD;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA,qCAAqC,cAAc,EAAE;AACrD;EACE,+BAA+B,eAAe,EAAE;AAClD;;AAEA,UAAU;AACV;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;AACA,uDAAuD,qCAAqC,EAAE;AAC9F;EACE,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA,mDAAmD,wBAAwB,EAAE;AAC7E,kDAAkD,8BAA8B,EAAE;AAClF;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA,mDAAmD,8BAA8B,EAAE;AACnF;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,kCAAkC;AACpC;AACA,0DAA0D,wBAAwB,EAAE;AACpF,yDAAyD,8BAA8B,EAAE;;AAEzF;;sEAEsE;AACtE,qBAAqB,kBAAkB,EAAE;AACzC,sBAAsB,eAAe,EAAE,gBAAgB,EAAE;AACzD,sBAAsB,YAAY,EAAE,sBAAsB,EAAE,eAAe,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACpH,8BAA8B,YAAY,EAAE,iBAAiB,EAAE;AAC/D,yBAAyB,eAAe,EAAE,kBAAkB,EAAE;AAC9D,qBAAqB,iBAAiB,EAAE;AACxC,uBAAuB,kBAAkB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE;AAC3F;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,YAAY,EAAE,sBAAsB,EAAE,eAAe,EAAE,kBAAkB;EACzE,eAAe,EAAE,cAAc;EAC/B,kFAAkF;AACpF;AACA,0BAA0B,cAAc,EAAE,cAAc,EAAE;AAC1D,2CAA2C,qCAAqC,EAAE,qCAAqC,EAAE;AACzH,0CAA0C,oBAAoB,gBAAgB,EAAE,EAAE;;AAElF,yDAAyD;AACzD,0BAA0B,cAAc,EAAE;AAC1C,8CAA8C,cAAc,EAAE","sourcesContent":[".panel-editor-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: var(--color-overlay-bg, rgba(0,0,0,0.5));\n  /* nested 모달 (다른 모달 위에 띄움) — 부모 modal(z:1001) 보다 위. */\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.panel-editor {\n  background: white;\n  border-radius: 10px;       /* 다른 모달과 통일 (8 → 10) */\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\n  width: 620px;\n  max-width: calc(95vw / var(--app-zoom, 1));\n  height: calc(85vh / var(--app-zoom, 1));          /* 고정 높이 — 내부 컨텐츠 변화에도 모달 크기 일정 */\n  max-height: calc(90vh / var(--app-zoom, 1));\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.panel-editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 16px;        /* 다른 모달과 통일 (12 → 10) */\n  background: #f8f9fa;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.panel-editor-header h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.panel-editor-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6b7280;\n}\n\n.panel-editor-body {\n  padding: 20px;             /* 다른 모달과 통일 (16 → 20) */\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n  min-height: 0;\n}\n\n.panel-editor-row {\n  display: flex;\n  gap: 12px;\n}\n\n.panel-editor-label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n  color: #374151;\n  font-weight: 500;\n}\n\n.panel-editor-input {\n  padding: 7px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 5px;\n  font-size: 13px;\n  color: #374151;\n  background: white;\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.panel-editor-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59,130,246,0.1);\n}\n\n.panel-editor-textarea {\n  padding: 8px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 5px;\n  font-family: var(--font-mono);\n  font-size: 12px;\n  color: #374151;\n  background: white;\n  resize: vertical;\n  min-height: 120px;\n  box-sizing: border-box;\n}\n\n.panel-editor-textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59,130,246,0.1);\n}\n\n.panel-editor-footer {\n  padding: 12px 16px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.panel-editor-btn {\n  padding: 7px 14px;\n  border-radius: 5px;\n  font-size: 13px;\n  cursor: pointer;\n  border: 1px solid #d1d5db;\n  background: white;\n  color: #374151;\n}\n\n.panel-editor-btn:hover {\n  background: #f3f4f6;\n}\n\n.panel-editor-btn-primary {\n  background: #3b82f6;\n  color: white;\n  border-color: #2563eb;\n}\n\n.panel-editor-btn-primary:hover {\n  background: #2563eb;\n}\n\n.panel-editor-btn-danger {\n  background: #ef4444;\n  color: white;\n  border-color: #dc2626;\n}\n\n.panel-editor-btn-danger:hover {\n  background: #dc2626;\n}\n\n/* Dark mode */\n[data-theme=\"dark\"] .panel-editor {\n  background: var(--color-bg-tertiary);\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .panel-editor-header {\n  background: var(--color-bg-secondary);\n  border-bottom-color: var(--color-border);\n}\n\n[data-theme=\"dark\"] .panel-editor-header h3 {\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .panel-editor-close {\n  color: var(--color-text-muted);\n}\n\n[data-theme=\"dark\"] .panel-editor-label {\n  color: var(--color-text-secondary);\n}\n\n[data-theme=\"dark\"] .panel-editor-input,\n[data-theme=\"dark\"] .panel-editor-textarea {\n  background: var(--color-input-bg);\n  border-color: var(--color-input-border);\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .panel-editor-input:focus,\n[data-theme=\"dark\"] .panel-editor-textarea:focus {\n  border-color: var(--color-accent-fg);\n}\n\n[data-theme=\"dark\"] .panel-editor-footer {\n  border-top-color: var(--color-border);\n}\n\n[data-theme=\"dark\"] .panel-editor-btn {\n  background: var(--color-bg-secondary);\n  color: var(--color-text);\n  border-color: var(--color-border);\n}\n\n[data-theme=\"dark\"] .panel-editor-btn:hover {\n  background: var(--color-hover);\n}\n\n/* ============================================================ */\n/* 확장 모드 — 2컬럼 레이아웃(입력 + 미리보기) + 템플릿/미리보기  */\n/* ============================================================ */\n.panel-editor-wide {\n  width: 1080px;\n  max-width: calc(97vw / var(--app-zoom, 1));\n}\n.panel-editor-split {\n  flex-direction: row;\n  gap: 20px;\n  padding: 16px;\n}\n/* split 모드에서는 외부 body 스크롤 금지 — form/preview 각자 내부에서 처리 */\n.panel-editor-body.panel-editor-split {\n  overflow: hidden;\n}\n.panel-editor-form {\n  flex: 1 1 58%;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow: hidden;     /* 내부 자식이 스크롤 책임 */\n}\n/* 상단 입력 필드 묶음 — 차트 옵션 미펼침 시 활성, 내부 스크롤 */\n.panel-editor-form-top {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n.panel-editor-preview {\n  flex: 1 1 42%;\n  min-width: 0;\n  min-height: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #fafafa;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.panel-editor-preview-header {\n  padding: 8px 12px;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  background: #f3f4f6;\n}\n.panel-editor-preview-header small {\n  font-weight: 400;\n  color: #6b7280;\n  font-size: 11px;\n}\n.panel-editor-preview-body {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n  min-height: 0;\n}\n.panel-editor-preview-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  padding-bottom: 6px;\n  border-bottom: 1px dashed #d1d5db;\n}\n.panel-editor-preview-meta {\n  font-size: 11px;\n  color: #6b7280;\n  line-height: 1.6;\n  padding-top: 4px;\n  border-top: 1px dashed #d1d5db;\n}\n.panel-editor-preview-meta strong {\n  color: #374151;\n  margin-right: 4px;\n}\n\n/* 강조 필드(데이터소스) */\n.panel-editor-prominent {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 6px;\n  padding: 8px 10px;\n  margin-bottom: 4px;\n}\n.panel-editor-prominent > select {\n  background: white;\n}\n/* 라벨 텍스트 한 줄 묶음 — 텍스트 + * 가 반드시 같은 줄에 위치하도록.\n   부모 .panel-editor-label 이 flex-column 이라 span 없이 두면 *가 다른 줄로 내려감. */\n.panel-editor-label-text {\n  display: inline-flex;\n  align-items: baseline;\n  white-space: nowrap;\n}\n.panel-editor-required {\n  color: #ef4444;\n  font-weight: 700;\n  margin-left: 4px;\n}\n.panel-editor-hint {\n  color: #6b7280;\n  font-size: 11px;\n  line-height: 1.5;\n}\n.panel-editor-hint-inline {\n  color: #6b7280;\n  font-size: 11px;\n  font-weight: 400;\n  margin-left: 4px;\n}\n.panel-editor-hint-inline code {\n  background: #f3f4f6;\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-size: 10px;\n  color: #1d4ed8;\n}\n.panel-editor-hint code {\n  background: #f3f4f6;\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-size: 10px;\n  color: #1d4ed8;\n}\n.panel-editor-input-error {\n  border-color: #dc2626 !important;\n  background: #fef2f2 !important;\n}\n[data-theme=\"dark\"] .panel-editor-hint-inline {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .panel-editor-hint-inline code,\n[data-theme=\"dark\"] .panel-editor-hint code {\n  background: var(--color-bg-secondary);\n  color: #93c5fd;\n}\n[data-theme=\"dark\"] .panel-editor-input-error {\n  background: rgba(220, 38, 38, 0.12) !important;\n  border-color: #ef4444 !important;\n}\n\n.panel-editor-btn-secondary {\n  background: #f3f4f6;\n  border-color: #d1d5db;\n  color: #4b5563;\n}\n.panel-editor-btn-secondary:hover {\n  background: #e5e7eb;\n}\n\n/* 다크 모드 보강 */\n[data-theme=\"dark\"] .panel-editor-preview {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-preview-header {\n  background: var(--color-bg-tertiary);\n  border-bottom-color: var(--color-border);\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .panel-editor-preview-header small,\n[data-theme=\"dark\"] .panel-editor-preview-meta {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .panel-editor-preview-title {\n  color: var(--color-text);\n  border-bottom-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-preview-meta {\n  border-top-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-preview-meta strong {\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .panel-editor-prominent {\n  background: rgba(59, 130, 246, 0.12);\n  border-color: rgba(59, 130, 246, 0.3);\n}\n[data-theme=\"dark\"] .panel-editor-hint {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .panel-editor-btn-secondary {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .panel-editor-btn-secondary:hover {\n  background: var(--color-hover);\n}\n\n/* 작은 화면 — 가로 공간 부족 시 세로 스택 */\n@media (max-width: 900px) {\n  .panel-editor-wide { width: 620px; }\n  .panel-editor-split { flex-direction: column; }\n  .panel-editor-preview { min-height: 320px; }\n}\n\n/* ============================================================ */\n/* 차트 옵션 섹션 — 컴팩트 + 내부 스크롤 (모달 전체 스크롤 방지) */\n/* ============================================================ */\n@keyframes panel-editor-fade-swap {\n  from { opacity: 0; transform: translateY(-3px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* 폼 상단 탭 — 기본 / 차트 옵션 / 전역변수.\n   각 탭 클릭 시 하위 conditional content 가 swap 되고 활성 탭은 파란 underline 강조. */\n.panel-editor-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n  margin-bottom: 4px;\n}\n.panel-editor-tab {\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  padding: 7px 14px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #6b7280;\n  margin-bottom: -1px;   /* 부모 border-bottom 과 겹쳐 두꺼워지는 것 방지 */\n  transition: color 160ms ease, border-color 160ms ease, background-color 160ms ease;\n}\n.panel-editor-tab:hover {\n  color: #374151;\n  background: #f9fafb;\n}\n.panel-editor-tab-active {\n  color: #1e40af;\n  border-bottom-color: #3b82f6;\n  font-weight: 600;\n}\n@media (prefers-reduced-motion: reduce) {\n  .panel-editor-tab { transition: none; }\n}\n\n/* 차트 옵션 펼침 / 접힘 시 내용물 fade-in (mount 직후 1회). */\n.panel-editor-form-top,\n.panel-editor-section {\n  animation: panel-editor-fade-swap 160ms ease-out;\n}\n\n/* OS-level reduced motion 선호 시 애니메이션/트랜지션 비활성 */\n@media (prefers-reduced-motion: reduce) {\n  .panel-editor-form-top,\n  .panel-editor-section {\n    transition: none;\n    animation: none;\n  }\n}\n/* 차트 옵션 본문 — flex:1 로 form 영역을 채우며, 내부에서 스크롤 */\n.panel-editor-section {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #fafafa;\n  overflow: hidden;\n}\n.panel-editor-section-content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.panel-editor-subsection {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 6px 8px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n}\n.panel-editor-subsection-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1f2937;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-bottom: 2px;\n}\n/* 컴팩트 row — 작은 gap, 모든 자식 라벨 한 줄 */\n.panel-editor-row-compact {\n  display: flex;\n  gap: 8px;\n  align-items: flex-end;\n}\n.panel-editor-row-compact .panel-editor-label {\n  font-size: 11px;\n  font-weight: 500;\n  gap: 2px;\n}\n.panel-editor-row-compact .panel-editor-input {\n  padding: 4px 6px;\n  font-size: 12px;\n}\n.panel-editor-checkbox-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  color: #374151;\n  cursor: pointer;\n}\n.panel-editor-checkbox-label input[type=\"checkbox\"] {\n  cursor: pointer;\n}\n/* Y컬럼 테이블 — flex:1 로 남은 공간 차지, 내부 스크롤 */\n.panel-editor-yfield-scroll {\n  flex: 1;\n  min-height: 80px;\n  max-height: 240px;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  background: white;\n}\n.panel-editor-yfield-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n.panel-editor-yfield-table thead {\n  position: sticky;\n  top: 0;\n  background: #f9fafb;\n  z-index: 1;\n}\n.panel-editor-yfield-table th {\n  text-align: left;\n  font-weight: 500;\n  color: #6b7280;\n  padding: 4px 8px;\n  border-bottom: 1px solid #e5e7eb;\n  font-size: 11px;\n}\n.panel-editor-yfield-table td {\n  padding: 3px 8px;\n  border-bottom: 1px solid #f3f4f6;\n  vertical-align: middle;\n}\n.panel-editor-yfield-table tr:last-child td {\n  border-bottom: none;\n}\n.panel-editor-yfield-table code {\n  background: #f3f4f6;\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-size: 11px;\n  color: #1f2937;\n}\n/* 색상 선택 — 트리거 swatch + Portal 기반 중앙 모달 팝업.\n   상위 overflow:hidden 에 clip 되지 않도록 document.body 에 렌더. */\n.panel-editor-color-swatch {\n  width: 32px;\n  height: 22px;\n  padding: 0;\n  border: 1px solid #d1d5db;\n  border-radius: 3px;\n  cursor: pointer;\n  background: transparent;\n  transition: border-color 160ms ease, transform 100ms ease;\n}\n.panel-editor-color-swatch:hover {\n  border-color: #6b7280;\n  transform: scale(1.05);\n}\n\n/* 모달 overlay + 본문 */\n.panel-editor-color-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: panel-editor-fade-swap 160ms ease-out;\n}\n.panel-editor-color-modal {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.25);\n  min-width: 280px;\n  max-width: calc(90vw / var(--app-zoom, 1));\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.panel-editor-color-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e5e7eb;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2937;\n}\n.panel-editor-color-modal-close {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 2px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 3px;\n  transition: color 160ms ease, background-color 160ms ease;\n}\n.panel-editor-color-modal-close:hover {\n  color: #1f2937;\n  background: #e5e7eb;\n}\n.panel-editor-color-modal-body {\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.panel-editor-color-modal-palette {\n  display: grid;\n  grid-template-columns: repeat(5, 36px);\n  gap: 8px;\n}\n.panel-editor-color-modal-swatch {\n  width: 36px;\n  height: 36px;\n  border: 2px solid transparent;\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 0;\n  transition: transform 100ms ease, border-color 100ms ease;\n}\n.panel-editor-color-modal-swatch:hover {\n  border-color: #9ca3af;\n  transform: scale(1.08);\n}\n.panel-editor-color-modal-swatch-active {\n  border-color: #1f2937;\n  transform: scale(1.08);\n}\n.panel-editor-color-modal-custom {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-top: 8px;\n  border-top: 1px dashed #d1d5db;\n  font-size: 12px;\n  color: #374151;\n}\n.panel-editor-color-modal-custom input[type=\"color\"] {\n  width: 36px;\n  height: 28px;\n  padding: 0;\n  border: 1px solid #d1d5db;\n  border-radius: 3px;\n  cursor: pointer;\n  background: transparent;\n}\n.panel-editor-color-modal-hex {\n  flex: 1;\n  padding: 4px 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 3px;\n  font-size: 12px;\n  font-family: var(--font-mono);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .panel-editor-color-modal-overlay,\n  .panel-editor-color-modal-swatch,\n  .panel-editor-color-swatch { animation: none; transition: none; }\n}\n.panel-editor-input-compact {\n  padding: 3px 5px;\n  font-size: 11px;\n  border: 1px solid #d1d5db;\n  border-radius: 3px;\n  background: white;\n  color: #374151;\n}\n\n/* 다크 모드 보강 */\n[data-theme=\"dark\"] .panel-editor-tabs {\n  border-bottom-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-tab {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .panel-editor-tab:hover {\n  color: var(--color-text);\n  background: var(--color-hover);\n}\n[data-theme=\"dark\"] .panel-editor-tab-active {\n  color: #93c5fd;\n  border-bottom-color: #60a5fa;\n}\n[data-theme=\"dark\"] .panel-editor-section {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-subsection {\n  background: var(--color-bg-tertiary);\n  border-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-subsection-title {\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .panel-editor-checkbox-label {\n  color: var(--color-text-secondary);\n}\n[data-theme=\"dark\"] .panel-editor-yfield-scroll {\n  background: var(--color-bg-tertiary);\n  border-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-yfield-table thead {\n  background: var(--color-bg-secondary);\n}\n[data-theme=\"dark\"] .panel-editor-yfield-table th {\n  color: var(--color-text-muted);\n  border-bottom-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-yfield-table td {\n  border-bottom-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-yfield-table code {\n  background: var(--color-bg-secondary);\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .panel-editor-color-swatch {\n  border-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-color-swatch:hover {\n  border-color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .panel-editor-color-modal {\n  background: var(--color-bg-tertiary);\n  box-shadow: 0 8px 32px rgba(0,0,0,0.6);\n}\n[data-theme=\"dark\"] .panel-editor-color-modal-header {\n  background: var(--color-bg-secondary);\n  border-bottom-color: var(--color-border);\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .panel-editor-color-modal-close {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .panel-editor-color-modal-close:hover {\n  color: var(--color-text);\n  background: var(--color-hover);\n}\n[data-theme=\"dark\"] .panel-editor-color-modal-swatch:hover {\n  border-color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .panel-editor-color-modal-swatch-active {\n  border-color: var(--color-text);\n}\n[data-theme=\"dark\"] .panel-editor-color-modal-custom {\n  color: var(--color-text-secondary);\n  border-top-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-color-modal-custom input[type=\"color\"] {\n  border-color: var(--color-input-border);\n}\n[data-theme=\"dark\"] .panel-editor-color-modal-hex {\n  background: var(--color-input-bg);\n  border-color: var(--color-input-border);\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .panel-editor-input-compact {\n  background: var(--color-input-bg);\n  border-color: var(--color-input-border);\n  color: var(--color-text);\n}\n\n/* ============================================================ */\n/* SubPanelPicker — 병합(merged) 차트의 sub-패널 선택 UI         */\n/* ============================================================ */\n.panel-editor-subpanel-picker { display: contents; }\n.panel-editor-subpanel-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 6px;\n  padding: 6px;\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  min-height: 60px;\n}\n.panel-editor-subpanel-empty {\n  color: #9ca3af;\n  font-size: 12px;\n  font-style: italic;\n  text-align: center;\n  padding: 12px 8px;\n}\n.panel-editor-subpanel-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 6px;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 12px;\n  /* 부드러운 hover (UI Conventions: 색상 한정 transition) */\n  transition: border-color 160ms ease;\n}\n.panel-editor-subpanel-row:hover { border-color: #9ca3af; }\n.panel-editor-subpanel-row-missing {\n  background: #fef3c7;\n  border-color: #fcd34d;\n}\n.panel-editor-subpanel-index {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: #e5e7eb;\n  border-radius: 50%;\n  font-size: 11px;\n  font-weight: 600;\n  color: #4b5563;\n  flex-shrink: 0;\n}\n.panel-editor-subpanel-title {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #1f2937;\n  font-weight: 500;\n}\n.panel-editor-subpanel-type {\n  flex-shrink: 0;\n  color: #6b7280;\n  font-size: 11px;\n}\n.panel-editor-subpanel-type code {\n  background: #e5e7eb;\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-size: 10px;\n}\n.panel-editor-subpanel-add { margin-top: 6px; }\n.panel-editor-subpanel-warn {\n  margin-top: 6px;\n  padding: 6px 10px;\n  background: #fef3c7;\n  border: 1px solid #fcd34d;\n  border-radius: 4px;\n  color: #92400e;\n  font-size: 11px;\n  /* fade-in (UI Conventions: 120~200ms ease-out) */\n  animation: panel-editor-fade-swap 160ms ease-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .panel-editor-subpanel-row { transition: none; }\n  .panel-editor-subpanel-warn { animation: none; }\n}\n\n/* 미리보기 영역 하단 — 저장 전 검증 결과 안내 ('주의') */\n.panel-editor-preview-warnings {\n  margin-top: 10px;\n  padding: 8px 12px;\n  background: #fef3c7;\n  border: 1px solid #fcd34d;\n  border-radius: 6px;\n  color: #92400e;\n  font-size: 12px;\n  line-height: 1.5;\n  /* fade-in (UI Conventions: 120~200ms ease-out) */\n  animation: panel-editor-fade-swap 160ms ease-out;\n}\n.panel-editor-preview-warnings-title {\n  font-weight: 600;\n  margin-bottom: 4px;\n  color: #78350f;\n}\n.panel-editor-preview-warnings ul {\n  margin: 0;\n  padding-left: 18px;\n}\n.panel-editor-preview-warnings li {\n  margin: 2px 0;\n}\n[data-theme=\"dark\"] .panel-editor-preview-warnings {\n  background: rgba(245, 158, 11, 0.12);\n  border-color: rgba(245, 158, 11, 0.4);\n  color: #fbbf24;\n}\n[data-theme=\"dark\"] .panel-editor-preview-warnings-title { color: #fde68a; }\n@media (prefers-reduced-motion: reduce) {\n  .panel-editor-preview-warnings { animation: none; }\n}\n\n/* 병합 패널 — 미리보기 영역 안내 박스 */\n.panel-editor-preview-merged {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 18px 14px;\n  background: #f8fafc;\n  border: 1px dashed #cbd5e1;\n  border-radius: 6px;\n  color: #475569;\n  font-size: 12px;\n  text-align: center;\n  animation: panel-editor-fade-swap 160ms ease-out;\n}\n.panel-editor-preview-merged strong {\n  font-size: 13px;\n  color: #1f2937;\n}\n.panel-editor-preview-merged small { color: #6b7280; }\n@media (prefers-reduced-motion: reduce) {\n  .panel-editor-preview-merged { animation: none; }\n}\n\n/* 다크 모드 */\n[data-theme=\"dark\"] .panel-editor-subpanel-list {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-subpanel-row {\n  background: var(--color-bg-tertiary);\n  border-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panel-editor-subpanel-row:hover { border-color: var(--color-text-muted); }\n[data-theme=\"dark\"] .panel-editor-subpanel-row-missing {\n  background: rgba(245, 158, 11, 0.15);\n  border-color: rgba(245, 158, 11, 0.4);\n}\n[data-theme=\"dark\"] .panel-editor-subpanel-index {\n  background: var(--color-bg);\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .panel-editor-subpanel-title { color: var(--color-text); }\n[data-theme=\"dark\"] .panel-editor-subpanel-type { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .panel-editor-subpanel-type code {\n  background: var(--color-bg);\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .panel-editor-subpanel-empty { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .panel-editor-subpanel-warn {\n  background: rgba(245, 158, 11, 0.18);\n  border-color: rgba(245, 158, 11, 0.4);\n  color: #fbbf24;\n}\n[data-theme=\"dark\"] .panel-editor-preview-merged {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n  color: var(--color-text-secondary);\n}\n[data-theme=\"dark\"] .panel-editor-preview-merged strong { color: var(--color-text); }\n[data-theme=\"dark\"] .panel-editor-preview-merged small { color: var(--color-text-muted); }\n\n/* ===== 세션 분석 · 오라클 성능 분석 기준으로 맞춤 (2026-10-03, 모니터링 메뉴 4개 창 공통) =====\n   본문 12px · 표(머리 6/8px 회색 바탕 + 아래 2px 선, 칸 5/8px + 1px 선) · 버튼·입력 30px · 필터는 리본 · 발 영역 회색 줄.\n   앞 규칙을 지우지 않고 뒤에서 덮는다(분리 창·전체 화면이 같은 클래스를 쓴다). 색 전환만(all 트랜지션 아님). */\n.panel-editor-body { padding: 12px 16px; }\n.panel-editor-label { font-size: 12px; font-weight: 600; }\n.panel-editor-input { height: 30px; box-sizing: border-box; padding: 0 10px; font-size: 12.5px; border-radius: 4px; }\ntextarea.panel-editor-input { height: auto; padding: 6px 10px; }\n.panel-editor-textarea { font-size: 12px; border-radius: 4px; }\n.panel-editor-hint { font-size: 11.5px; }\n.panel-editor-footer { padding: 10px 16px; background: #f8f9fa; border-top-color: #e0e0e0; }\n.panel-editor-btn {\n  display: inline-flex; align-items: center; gap: 6px;\n  height: 30px; box-sizing: border-box; padding: 0 14px; border-radius: 6px;\n  font-size: 13px; line-height: 1;\n  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n.panel-editor-btn > svg { display: block; flex-shrink: 0; }\n[data-theme=\"dark\"] .panel-editor-footer { background: var(--color-bg-secondary); border-top-color: var(--color-border); }\n@media (prefers-reduced-motion: reduce) { .panel-editor-btn { transition: none; } }\n\n/* 노드를 고르며 SQL 을 고친 사실(2026-10-18) — 바뀐 것을 놓치지 않게 강조색으로 */\n.panel-editor-node-note { color: #b45309; }\n[data-theme=\"dark\"] .panel-editor-node-note { color: #fbbf24; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
